var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoColorSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.229167 7.20116V10.8012H0.00875716C0.00875716 10.8012 -0.0102259 10.8012 0.00770615 10.8012H0.229167H3.82917V14.4012H0.00875716C0.828125 16.002 2.32812 17.502 3.82812 18.0012L3.82917 14.4012H7.42917V18.0012H11.0292V14.4012H14.6292V18.0012C16.3281 17.502 17.689 16.002 17.8687 14.4012H14.6292V10.8012H17.8687C17.8687 10.8012 17.8687 7.81749 17.8687 7.20116H14.6292V3.60116H17.8687C17.689 2.17007 16.3281 0.501953 14.6292 0.000246825V3.60116H11.0292V0.00215817L7.42917 0V3.60116H3.82917V0.00215817C1.82812 0.502955 0.328125 2.10195 0.00875716 3.60116H3.82917V7.20116H0.229167ZM7.42917 7.20116V3.60116H11.0292V7.20116H7.42917ZM7.42917 7.20116V10.8012H3.82917V7.20116H7.42917ZM11.0292 7.20116H14.6292V10.8012H11.0292V7.20116ZM11.0292 10.8012V14.4012H7.42917V10.8012H11.0292Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoColorSquare);
export default __webpack_public_path__ + "static/media/no-color-square.00bf914b2da5406fc326a677589e1108.svg";
export { ForwardRef as ReactComponent };